export function kebabRules(rulePairs, index) {
    rulePairs[index] = rulePairs[index].replace(/([A-Z])/g, '-$1').toLowerCase();
}
//# sourceMappingURL=kebabRules.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/merge-styles/lib/transforms/kebabRules.js
// module id = 483
// module chunks = 0